import Button from "kustom-front/src/components/atoms/Button";
import { FunctionComponent, useCallback, useState } from "react";
import { useIntl } from "react-intl";
import Input from "@Components/atoms/Input";
import useNotificationsContext from "@Hooks/useNotificationsContext";
import { ScreenParams } from "@Types/login";
import { emailPattern } from "@Utils/checkFormats";
import { logNewUserWithProvider, logUserWithEmail } from "./utils";
import "./style.scss";

interface Props {
  onChangeScreen: (newScreenParams: ScreenParams) => void;
  params: ScreenParams;
}

const Email: FunctionComponent<Props> = ({ onChangeScreen, params }) => {
  const [email, setEmail] = useState<string>("");
  const [submittedForm, setSubmittedForm] = useState<boolean>(false);
  const intl = useIntl();
  const { dispatchNotification } = useNotificationsContext();

  const handleSubmit = useCallback(
    (event: React.FormEvent<HTMLFormElement> | React.MouseEvent<Element, MouseEvent>) => {
      event.preventDefault();
      setSubmittedForm(true);

      if (email && params.token && params.provider) {
        logNewUserWithProvider(
          { email, provider: params.provider, token: params.token },
          onChangeScreen,
          dispatchNotification,
          intl.locale
        );
      } else if (email) {
        logUserWithEmail(email, onChangeScreen, dispatchNotification, intl.locale);
      } else {
        dispatchNotification({
          code: "CFE-006",
          type: "addNotificationByCode",
        });
      }
    },
    [dispatchNotification, email, onChangeScreen, params]
  );

  return (
    <div className="Email">
      <div className="Email-title">
        {params.token
          ? intl.formatMessage({ id: "cheerz_LoginModal_confirmEmail_title" })
          : intl.formatMessage({ id: "cheerz_LoginModal_email_title" })}
      </div>
      <form onSubmit={handleSubmit}>
        <Input
          autofocus={true}
          name="email"
          onChange={(newEmail: string) => setEmail(newEmail)}
          pattern={emailPattern}
          placeholder={intl.formatMessage({ id: "cheerz_LoginModal_email_input" })}
          required={true}
          submitted={submittedForm}
          type="email"
          value={email}
        />
        <Button type="primary" onClick={handleSubmit}>
          {intl.formatMessage({ id: "cheerz_LoginModal_email_button" })}
        </Button>
      </form>
    </div>
  );
};

export default Email;
